// ----------------------------------------------------------
// © Copyright 2021 European Space Agency, 2021
// This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this [source code/executable] package. No part of the package, including this file, may be copied, modified, propagated, or distributed except according to the terms contained in the file ‘LICENSE.txt’.
// -----------------------------------------------------------
import dayjs from "dayjs";
import { isDefined, isUndefined } from "../helpers/check";
import { appState } from '../store';
const TTL_REGEXP = /(\d*)(\w*)/;
class StorageManager {
    constructor() {
        this.CACHE_ENABLED = false;
        this.INFINITY = 'infinity';
    }
    utf8ToB64(str) {
        return window.btoa ? window.btoa(encodeURIComponent(str)) : encodeURIComponent(str);
    }
    /**
     * Store the data with meta data like time to live
     * @param data the data, could be anything
     * @param key base key for the retrieve
     * @param userSpecific is the data linked to a user
     * @param ttl live duration of the data, 24hours, 2days...
     */
    store(data, key, userSpecific = false, ttl = "24hours") {
        const match = TTL_REGEXP.exec(ttl);
        // if the developer set the retention to infinity we will put undefined which means Stringify will remove it
        const ts = ttl == this.INFINITY ? undefined : +dayjs().add(+match[1], match[2]);
        localStorage.setItem(`${key}.${userSpecific ? appState.user.username : '*'}`, JSON.stringify({ data, ts }));
    }
    /**
     * Retrieve the stored data in the storage and check the time validity before returning
     * Returns the data if valid and exists
     * Returns undefined if no data or data is not valid anymore
     * @param key
     * @returns
     */
    retrieve(key) {
        let currentKey = `${key}.*`;
        let storedData = localStorage.getItem(currentKey);
        // the data to be returned
        let data;
        if (isUndefined(storedData) && isDefined(appState.user)) {
            currentKey = `${key}.${appState.user.username}`;
            storedData = localStorage.getItem(currentKey);
        }
        if (isDefined(storedData)) {
            const storedDataObject = JSON.parse(storedData);
            if (isDefined(storedDataObject.ts) && storedDataObject.ts < +dayjs()) {
                // if the timestamp is over we clean the value and return undefined to the user
                data = undefined;
                // clean the storage as this data is no more valid
                localStorage.removeItem(currentKey);
            }
            else {
                // case of infinit retention or data still valid
                data = storedDataObject.data;
            }
        }
        return data;
    }
    /**
     * remove the key in the storage
     * @param key
     */
    remove(key) {
        let currentKey = `${key}-*`;
        localStorage.removeItem(currentKey);
        if (isDefined(appState.user)) {
            currentKey = `${key}-${appState.user.username}`;
            localStorage.removeItem(currentKey);
        }
    }
}
// export a singleton
export const storageManager = new StorageManager();
